import styled, { keyframes } from "styled-components";

const move = keyframes`
    50% {
        transform: translate3d(100vw, 0, 0);
    }
`;

export const MovingTrayContainer = styled.div`
    transform: translateZ(0);
    backface-visibility: hidden;
`;

export const MovingTray = styled.div`
    width: 28px;
    background-color: ${props => props.theme.colors.light.primary};
    height: 2px;
    transform: translateZ(0);
    will-change: transform;
    backface-visibility: hidden;
    border-radius: 100px;
    position: relative;
    top: -2px;
    animation: ${move} linear 2s infinite;
`;
